import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { IPrNewsSFilter } from 'src/@types/SearchFilterTypes';
import { RHFSelect, RHFTextField } from 'src/components/hook-form';
import FormProvider from 'src/components/hook-form/FormProvider';
import { FormItem, SearchFormLayout } from 'src/layouts/form/FormLayout';
import { useStores } from 'src/models';
import removeNullUndefined from 'src/utils/removeNullUndefined';

export interface ISearchFormProps {
  onSearch: (data: IPrNewsSFilter) => void;
}

export const SearchForm = observer(({ onSearch }: ISearchFormProps) => {
  const { t } = useTranslation();
  const methods = useForm<IPrNewsSFilter>({ defaultValues: { prNewsCtgyCd: '' } });
  const { commonCodeStore } = useStores();
  const { newsSelectOptions } = commonCodeStore;

  // 검색 함수
  const onValid = (data: IPrNewsSFilter) => {
    const cleanedData = removeNullUndefined(data);
    onSearch(cleanedData);
  };

  return (
    <FormProvider methods={methods} onSubmit={methods.handleSubmit(onValid)}>
      <SearchFormLayout method={methods} open={true} cols={2}>
        <FormItem>
          <RHFSelect
            label={t('news.fields.category')}
            name="prNewsCtgyCd"
            options={newsSelectOptions}
          />
        </FormItem>
        <FormItem>
          <RHFTextField label={t('news.fields.searchText')} name="searchText" />
        </FormItem>
      </SearchFormLayout>
    </FormProvider>
  );
});

export default SearchForm;
